module.exports = __webpack_public_path__ + "static/img/pic-03.f00a408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic-03.png
// module id = RTXE
// module chunks = 1